export default __webpack_public_path__ + "static/media/ExtraLife_Icon_SVG.2ee5315f.svg";